import React from 'react';
import Modal from '../Modal';

import { Box, Img, NoButton, Text, Title, WrapButton, YesButton } from './AllertPrro.styled';

import Image from '../../../images/AllertFinance.png'

import { useNavigate } from 'react-router-dom';



const AllertPrro= ({ onClose,onFunc }) => {




  return (
    <Modal onClose={onClose}>
      <Box>
        <Img src={Image} alt="Вихід" />
        <Title>Ви не заповнили дані ПРРО</Title>
        <Text>Для даної точки видачі не вказані дані ПРРО. Фіскалізація продажу не відбудеться</Text>
        <WrapButton>

          <YesButton
            onClick={() => { onFunc(); onClose(); }}>Продовжити без фіскалізації</YesButton>

        </WrapButton>
      </Box>

    </Modal>
  );
};

export default AllertPrro;
